import { EmailOnlyModal } from 'components/authentication_modals/EmailOnlyModal'
import SignInModal from 'components/authentication_modals/SignInModal'
import SignUpModal from 'components/authentication_modals/SignUpModal'
import ReactRailsUJS from 'react_ujs'

/**
 * Table of all the components needed in this pack. To add a component, put the string you pass into
 * `react-rails` on the left hand side, and a `require` statement for the component on the right.
 */
const components = {
  'authentication_modals/EmailOnlyModal': EmailOnlyModal,
  'authentication_modals/SignInModal': SignInModal,
  'authentication_modals/SignUpModal': SignUpModal
}

/**
 * Mocks the context function returned from `require.context`. The context function takes
 * in a string and returns the module. The string in this case is what's passed into the
 * `react_component` helper. For some reason, `react-rails` prepends the string sometimes
 * with a relative path (starting with "./")`, so we remove that here. Then we just return
 * a function from our table above.
 * @param fileToImport {String}
 * @returns {*}
 */
function componentLoadPathContext (fileToImport) {
  return components[fileToImport.replace(/^\.\//, '')]
}

ReactRailsUJS.useContext(componentLoadPathContext)
